module.exports = __webpack_public_path__ + "static/1201069511.74d8b53f.jpg";